import { Collapse } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { WrapperLateral } from './styled'

interface PropsLateral {
  analises: any[]
  atualizarCoresDosPontos: Function
  selecionado: number
  setSelecionado: React.Dispatch<React.SetStateAction<number>>
}

export const LateralVerAnalises: React.FC<PropsLateral> = ({
  analises,
  atualizarCoresDosPontos,
  selecionado,
  setSelecionado
}) => {
  const { Panel } = Collapse

  return (
    <WrapperLateral>
      <h3 className='lateral__title'>Análises cadastradas</h3>
      <Collapse accordion>
        {analises.map((item, index) => (
          <Panel
            key={index}
            header={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 5,
                }}
              >
                <span style={{ margin: 0, padding: 0, fontWeight: 600 }}>
                  {item.profundidade}
                </span>
                <div
                  className='button__eye'
                  style={
                    {
                      '--cor-do-item': item?.cor,
                    } as React.CSSProperties
                  }
                  onClick={(e) => { e.stopPropagation(); atualizarCoresDosPontos(item) }}
                  data-active={item?.id === selecionado}
                >
                  <FontAwesomeIcon icon={faEye} fontSize={13} />
                </div>
              </div>
            }
          >
            <div className='container__adicionados'>
              <div className='header__adicionados'>
                <div className='nome__analise' style={{ backgroundColor: item?.cor }}>
                  {item?.analise_nome}
                </div>
              </div>

              <h3 className='points-title'>Pontos</h3>

              <div className='points-grid'>
                {item?.pontos_selecionados?.map((point, index) => (
                  <div
                    key={index}
                    className='point-card'
                    style={
                      {
                        '--cor-do-item': point?.COR,
                      } as React.CSSProperties
                    }
                  >
                    {point?.NOME.toString().padStart(2, '0')}
                  </div>
                ))}
              </div>
            </div>
          </Panel>
        ))}
      </Collapse>
    </WrapperLateral>
  )
}
